import SVTrackedUpgradeButtonContainer from '@apps/www/src/www/containers/SVTrackedUpgradeButtonContainer';
import usePersistentSetting, {
	PersistentSettingKeys,
} from '@apps/www/src/www/hooks/usePersistentSetting';
import { SVButtonSIZES } from '@pkgs/shared-client/components/SVButton';
import SVUpgradeFeaturesList from '@pkgs/shared-client/components/SVUpgradeFeaturesList';
import UpgradeButtonSource from '@pkgs/shared/enums/UpgradeButtonSource';
import { getUpsellBenefits } from '@pkgs/shared/plans';

const SVBottomGridUpsell = () => {
	const upsellBenefits = getUpsellBenefits();
	const [isDarkMode] = usePersistentSetting(PersistentSettingKeys.DARK_MODE);

	const upsellBenefitsClassNames = {
		checkIconClassName: 'bg-[#0015FF]',
		className: 'space-y-2 w-[240px]',
		featureLabelClassName: 'text-gray-400',
	};

	const blurBackgroundClass = isDarkMode
		? 'bg-[radial-gradient(circle,_#CAAFFF_30%,_#0039BF_100%)]'
		: 'bg-[radial-gradient(circle,_#0039BF_30%,_#CAAFFF_100%)]';

	return (
		<>
			<div
				className="relative mt-20 flex w-full justify-center overflow-hidden pb-9"
				title="Want to keep scrolling? Upgrade and keep scrolling"
			>
				<div className="relative z-10 flex w-[765px] max-w-[95%] flex-col px-6">
					<div className="flex flex-1 flex-col justify-center gap-y-3">
						<div className="type-small-title text-primary text-center font-semibold">
							Upgrade and keep&nbsp;scrolling
						</div>
						<div className="type-label text-center font-medium text-gray-400">
							Unlimited inspiration and features built for creatives like you.
						</div>
					</div>
					<div className="mt-9 text-center text-xl font-semibold text-gray-600">
						What's included
					</div>

					<div className="-sm:flex-col -sm:space-x-0 -sm:space-y-2 -sm:w-full -sm:items-center mx-auto mt-7 flex w-fit justify-center space-x-14">
						<SVUpgradeFeaturesList
							features={upsellBenefits.slice(0, upsellBenefits.length / 2)}
							{...upsellBenefitsClassNames}
						/>
						<SVUpgradeFeaturesList
							features={upsellBenefits.slice(upsellBenefits.length / 2)}
							{...upsellBenefitsClassNames}
						/>
					</div>
					<div className="mt-14 flex justify-center">
						<SVTrackedUpgradeButtonContainer
							source={UpgradeButtonSource.END_OF_GRID_UPSELL}
							size={SVButtonSIZES.PAYMENT}
						>
							Upgrade and continue
						</SVTrackedUpgradeButtonContainer>
					</div>
				</div>
				<div
					className={`pointer-events-none absolute bottom-[-620px] left-1/2 z-0 h-[600px] w-[800px] -translate-x-1/2 rounded-full ${blurBackgroundClass} blur-[140px]`}
				/>
			</div>
		</>
	);
};

export default SVBottomGridUpsell;
